module.exports = __webpack_public_path__ + "img/pen-size-2.1c66b360.svg";